'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _modal = require('../../../redux/modules/modal');

var _createAccount = require('../../../redux/modules/createAccount');

var _browser = require('../../../redux/modules/browser');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _analytics = require('../../../redux/modules/analytics');

var _bidderExists = require('../../../redux/modules/bidderExists');

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _whiteLabel = require('../../../redux/modules/whiteLabel');

var _enums = require('../../../enums');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUpModal = require('./SignUpModal');

var _SignUpModal2 = _interopRequireDefault(_SignUpModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    var attributionData = (0, _analytics.getAttributionData)(state);
    var bidderExists = (0, _bidderExists.getBidderExists)(state);

    var _getCreateAccountStat = (0, _createAccount.getCreateAccountState)(state),
        error = _getCreateAccountStat.error,
        submitted = _getCreateAccountStat.submitted,
        success = _getCreateAccountStat.success;

    var isMobile = !!(0, _browser.isUiMobile)(state);
    var isTablet = (0, _browser.isUiTablet)(state);
    var openModal = (0, _modal.getOpenModal)(state);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);

    return {
        attributionData: attributionData,
        bidderExists: bidderExists,
        error: error,
        isMobile: isMobile,
        isTablet: isTablet,
        openModal: openModal,
        submitted: submitted,
        success: success,
        whiteLabel: whiteLabel
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        dismissModal: _modal.dismissModal,
        openLoginModal: _modal.openLoginModal,
        openSetPasswordModal: _modal.openSetPasswordModal,
        submitCreateAccount: _createAccount.submitCreateAccount
    }, dispatch);
};

var SignUpModalContainer = function (_Component) {
    (0, _inherits3.default)(SignUpModalContainer, _Component);

    function SignUpModalContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SignUpModalContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SignUpModalContainer.__proto__ || (0, _getPrototypeOf2.default)(SignUpModalContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            email: ''
        }, _this.shouldComponentUpdate = function (nextProps, nextState) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps) || !(0, _reactFastCompare2.default)(_this.state, nextState);
        }, _this.setEmail = function (email) {
            _this.setState({ email: email });
        }, _this.submitCreateAccount = function (email, agree) {
            _this.props.submitCreateAccount(email, agree, _this.props.attributionData);
        }, _this.cancelSignUp = function () {
            _this.props.dismissModal();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SignUpModalContainer, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                bidderExists = _props.bidderExists,
                success = _props.success;


            if (success && !prevProps.success) {
                this.props.openSetPasswordModal();
            } else if (bidderExists && !prevProps.bidderExists) {
                this.props.openLoginModal();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var show = this.props.openModal === _enums.modalTypes.SIGN_UP;
            var _props2 = this.props,
                bidderExists = _props2.bidderExists,
                error = _props2.error,
                isMobile = _props2.isMobile,
                isTablet = _props2.isTablet,
                submitted = _props2.submitted,
                whiteLabel = _props2.whiteLabel;


            return (0, _jsx3.default)(_SignUpModal2.default, {
                bidderExists: bidderExists,
                cancelSignUp: this.cancelSignUp,
                error: error,
                isMobile: isMobile,
                isTablet: isTablet,
                openLoginModal: this.props.openLoginModal,
                setEmail: this.setEmail,
                show: show,
                submitCreateAccount: this.submitCreateAccount,
                submitted: submitted,
                whiteLabel: whiteLabel
            });
        }
    }]);
    return SignUpModalContainer;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SignUpModalContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/SignUpModal/SignUpModalContainer.js
// module id = KmPa
// module chunks = 60